import { useLayoutEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export default function useScrollTriggerAnimation(
  ref: React.RefObject<HTMLElement>
) {

  // const pauseParticles = () => {
  //   if(window.pJSDom && window.pJSDom[0]  && window.pJSDom[0].pJS){

  //   }
  // }
  useLayoutEffect(() => {
    let scrollTriggerInstance: gsap.core.Tween | undefined; //ReturnType<typeof gsap.to>
    if (ref.current) {
      const target = ref.current;

      scrollTriggerInstance = gsap.to(target, {
        scrollTrigger: {
          trigger: document.documentElement,
          start: 0,
          end: 80,
          onLeave: () => {
            // console.log("onLeave triggered");
            if (target) {
              gsap.to(ref.current, {
                scale: 1,
                duration: 0.35, //smoothness
                ease: "power1.out",
                transform: "translateZ(0)",// gpu acceleration
                force3D: true,
              });
            }
          },
          onEnterBack: () => {
            // console.log("onEnterBack triggered");
            if (target) {
              gsap.to(ref.current, {
                scale: 0,
                duration: 0.35,
                ease: "power1.in",
                transform: "translateZ(0)",// gpu acceleration
                force3D: true,
              });
            }
          },
        },
      });
    }

    return () => {
      if (scrollTriggerInstance) {
        scrollTriggerInstance.scrollTrigger?.kill(); // Clean up ScrollTrigger on unmount
      }
    };
  }, [ref]);
}
